import { render, staticRenderFns } from "./ServiceIcon.vue?vue&type=template&id=0243d951&scoped=true"
import script from "./ServiceIcon.vue?vue&type=script&lang=js"
export * from "./ServiceIcon.vue?vue&type=script&lang=js"
import style0 from "./ServiceIcon.vue?vue&type=style&index=0&id=0243d951&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0243d951",
  null
  
)

export default component.exports